/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCardRequest
 */
export interface GetCardRequest {
    /**
     * 
     * @type {string}
     * @memberof GetCardRequest
     */
    cardId: string;
}

export function GetCardRequestFromJSON(json: any): GetCardRequest {
    return GetCardRequestFromJSONTyped(json, false);
}

export function GetCardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCardRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardId': json['card_id'],
    };
}

export function GetCardRequestToJSON(value?: GetCardRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'card_id': value.cardId,
    };
}


